if (!customElements.get('article-toc')) {
  class ArticleToc extends HTMLElement {
    connectedCallback() {
      this.content = document.querySelector('.article-template__content');
      this.list = this.querySelector('[data-toc-list]');

      if (!this.content || !this.list) return;

      this.headings = [...this.content.querySelectorAll('h2, h3')];

      if (!this.headings.length) {
        this.hidden = true;
        return;
      }

      this.buildList();
      this.observeHeadings();
    }

    buildList() {
      this.headings.forEach((heading, index) => {
        if (!heading.id) {
          heading.id = `article-heading-${index + 1}`;
        }

        const item = document.createElement('li');
        item.className =
          heading.tagName === 'H3'
            ? 'article-template__toc-item article-template__toc-item--sub'
            : 'article-template__toc-item';

        const link = document.createElement('a');
        link.className = 'article-template__toc-link';
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        link.addEventListener('click', (event) => {
          event.preventDefault();
          heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', `#${heading.id}`);
          this.setActive(link);
        });

        item.appendChild(link);
        this.list.appendChild(item);
      });

      this.links = [...this.list.querySelectorAll('.article-template__toc-link')];
    }

    setActive(activeLink) {
      this.links.forEach((link) => {
        link.classList.toggle('is-active', link === activeLink);
      });
    }

    observeHeadings() {
      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

          if (!visible.length) return;

          const activeHeading = visible[0].target;
          const activeLink = this.links.find((link) => link.getAttribute('href') === `#${activeHeading.id}`);
          if (activeLink) this.setActive(activeLink);
        },
        {
          rootMargin: '-20% 0px -70% 0px',
          threshold: 0,
        }
      );

      this.headings.forEach((heading) => observer.observe(heading));
    }
  }

  customElements.define('article-toc', ArticleToc);
}
